import React from 'react'
import {connect} from 'dva'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {modelUtils} from '@/utils'

const {WizContainer} = framework_tool
const {isType} = utils_tool
import {WizInputNumber} from "wiz-components";
import {Col, Row} from "antd";

let {WizForm, WizButton, WizRow, WizCol, WizIcon, WizTooltip} = component_tool;

class CheckResourcesCount extends WizContainer {
  componentName = 'CheckResourcesCount'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime(),
      resourcesDate: [],
      type: null,
      msg: '',
    }
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(values) {
    let fitterValues = {};
    Object.keys(values).forEach(key => {
      const value = values[key];
      if (key === 'resourcesDate' && value != null && value != undefined) {
        fitterValues['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
        fitterValues['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  propsAndStateOnChange = {
    checkResult: this._checkResultOnChange.bind(this)
  }

  _checkResultOnChange(nextProps, nextState) {
    if (nextProps.checkResult.code === 1) {
      let msg = nextProps.checkResult.data;
      nextState.msg = msg;
      wizNotice.success('校验成功')
    } else {
      wizNotice.error(nextProps.checkResult.msg)
    }
    return true;
  }

  _onCheck = () => {
    this.refs.form.validateFields((err, values) => {
      if (!err) {
        this.setState({msg: ''})
        let fitterValues = this.fitterFieldsValue(values);
        this.doAction({
          path: 'interactLive/checkMeetingDate',
          payload: {
            key: 'interactLive@checkMeetingDate',
            apiParams: {...fitterValues}
          }
        })
      }
      return
    });
  }

  _onReset = () => {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    this.setState({msg: ''})
  }

  render() {
    const columns = [
      {
        title: '资源账号类型',
        name: 'type',
        dataIndex: 'type',
        formItem: {
          type: 'select',
          onChange: (form, value, e) => this.setState({type: value}),
          rules: [{required: true, message: '请选择资源账号类型'}],
        },
        dict: [
          {code: 1, codeName: '远程评估 '},
          {code: 2, codeName: '直播课堂/远程认证'}
        ]
      },
      {
        title: "时间区间",
        name: "resourcesDate",
        dataIndex: "resourcesDate",
        formItem: {
          type: 'date~',
          showTime: true,
          rules: [{required: true, message: '请选择校验的资源类型时间区间'}],
          onChange: (form, value, e) => this.setState({resourcesDate: value}),
        }
      },
      this.state.msg !='' ? {
        formItem: {
          type: 'custom',
          col: {span: 21},
          formItemLayout: {
            labelCol: {span: 0},
            wrapperCol: {span: 24}
          },
          render: () => {
            return <span style={{color: 'red'}}>{this.state.msg != '' ? '注意：' + this.state.msg : ''}</span>
          }
        }
      }: {
        formItem: {
          type: 'custom',
          col: {span: 21},
          formItemLayout: {
            labelCol: {span: 0},
            wrapperCol: {span: 24}
          },
          render: () => {
            return <span>{''}</span>
          }
        }
      },
    ]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record: {},
      preview: false,
      footer: <div/>,
      formItemLayout: {
        labelCol: {span: 5},
        wrapperCol: {span: 16}
      }
    }

    return (
      <div>
        <WizForm {...formProps} />
        <WizRow className="form-btns row-item">
          <WizCol span={24}>
            <WizButton title='校验' type='primary' onClick={() => this._onCheck()}>校验</WizButton>
            <WizButton title='重置' type='reset' onClick={() => this._onReset()}>重置</WizButton>
          </WizCol>
        </WizRow>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {interactLive} = state
  const checkResult = modelUtils.getModelEntity(interactLive, 'interactLive@checkMeetingDate')
  return {
    checkResult
  }
}

const options = {withRef: true}

export default connect(mapStateToProps, null, null, options)(CheckResourcesCount)
